import React, { useContext } from 'react';
import { ConversationsContext } from '../../../context/ConversationsProvider';
import { CurrentRecipientStyled } from './ConversationWindowStyled';
import useCurrentParticipantMember from './hooks/useCurrentParticipantMember';

const CurrentConversationHeader = () => {
    const { currentConversation } = useContext(ConversationsContext);
    const { currentParticipantMember } = useCurrentParticipantMember(currentConversation);

    if (!currentParticipantMember) return null;

    return (
        <CurrentRecipientStyled>
            To: {currentParticipantMember.firstName} {currentParticipantMember.lastName}
        </CurrentRecipientStyled>
    );
};

export default CurrentConversationHeader;
